import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/HomePage.css';

const HomePage = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/'); // redirects to Login page
  };

  return (
    <div className="home-page-container">
      <div className="main-content">
        <div className="illustration-wrapper">
          <img src="/test.png" alt="Laptop illustration" className="illustration" />
        </div>
        <div className="welcome-section">
          <h1 className="welcome-text">Welcome </h1>
          <p className="subtitle">Access your professional talent management platform</p>
          <div className="button-container">
            <button className="welcome-button" onClick={handleButtonClick}>
              Get Started <span className="arrow">→</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
